/**
 * This file is to initialize google client id
 * and utm source tracker
 */
import { create } from 'zustand';

interface DonationTrackerStore {
    gaId: string;
    initializeDonationTracker: (measurementId: string) => void;
}

export const useDonationTracker = create<DonationTrackerStore>(set => {
    return {
        gaId: '',
        initializeDonationTracker: (measurementId): void => {
            if (measurementId && typeof window.gtag !== 'undefined') {
                // set google analytic client id
                // to global state,
                // so it can be accessed easily
                gtag('get', measurementId, 'client_id', (id): void => {
                    set(() => {
                        return { gaId: id as string };
                    });
                });
            }
        },
    };
});
